var LoginEnum = /* @__PURE__ */ ((LoginEnum2) => {
  LoginEnum2["LOGIN_BUTTON"] = "login--button";
  LoginEnum2["LOGIN_INPUT_CPF"] = "login--input-cpf";
  LoginEnum2["LOGIN_INPUT_PASSWORD"] = "login--input-password";
  LoginEnum2["LOGIN_SUBMIT_BUTTON"] = "login--submit-button";
  return LoginEnum2;
})(LoginEnum || {});
export {
  LoginEnum
};
